// extracted by css-extract-rspack-plugin
export default {"cls1":"Page-cls1_Mm1","cls2":"Page-cls2_c9v Page-cls1_Mm1"};